module.exports = window.wp.serverSideRender